<template>
  <div class="m-card" :class="{ flex: double }">
    <div class="one">
      <div class="m-card__header">
        <div class="title-c">{{ title }}</div>
        <div class="icon-c" v-if="action && !titleB">
          <router-link :to="url">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.67981 13.6608C6.57743 13.5529 6.49606 13.4246 6.44034 13.2833C6.38462 13.142 6.35565 12.9904 6.35507 12.8372C6.3545 12.684 6.38234 12.5321 6.437 12.3903C6.49166 12.2486 6.57207 12.1196 6.67364 12.0109L10.2636 8.1664L1.09786 8.1664C0.806693 8.1664 0.527448 8.0435 0.321558 7.82473C0.115669 7.60596 9.35902e-07 7.30925 9.79178e-07 6.99987C1.02246e-06 6.69048 0.115669 6.39377 0.321559 6.175C0.527448 5.95623 0.806693 5.83333 1.09786 5.83333L10.2636 5.83333L6.67364 1.98887C6.46854 1.76902 6.35405 1.4716 6.35533 1.16204C6.35662 0.852487 6.47359 0.556152 6.6805 0.33823C6.88741 0.120308 7.16732 -0.00135402 7.45866 1.35966e-05C7.74999 0.00138121 8.02888 0.125664 8.23397 0.34552L13.6814 6.17819C13.8855 6.39669 14 6.69204 14 6.99987C14 7.30769 13.8855 7.60304 13.6814 7.82155L8.23397 13.6542C8.1324 13.7632 8.0116 13.8499 7.87848 13.9092C7.74536 13.9685 7.60253 13.9994 7.45817 14C7.31381 14.0006 7.17076 13.971 7.0372 13.9127C6.90364 13.8545 6.78219 13.7689 6.67981 13.6608Z"
                fill="#27884D"
              />
            </svg>
          </router-link>
        </div>
      </div>
      <div class="m-card__main">
        <div
          class="letter"
          :class="{ negative: name === 'debits' && data < 0 }"
        >
          <span v-if="name !== 'orders' && currency">{{ currency }} </span
          >{{ data }}
        </div>
      </div>
    </div>
    <div class="two" v-if="double">
      <div class="m-card__header">
        <div class="title-c">{{ titleB }}</div>
        <div class="icon-c" v-if="action">
          <router-link :to="url">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.67981 13.6608C6.57743 13.5529 6.49606 13.4246 6.44034 13.2833C6.38462 13.142 6.35565 12.9904 6.35507 12.8372C6.3545 12.684 6.38234 12.5321 6.437 12.3903C6.49166 12.2486 6.57207 12.1196 6.67364 12.0109L10.2636 8.1664L1.09786 8.1664C0.806693 8.1664 0.527448 8.0435 0.321558 7.82473C0.115669 7.60596 9.35902e-07 7.30925 9.79178e-07 6.99987C1.02246e-06 6.69048 0.115669 6.39377 0.321559 6.175C0.527448 5.95623 0.806693 5.83333 1.09786 5.83333L10.2636 5.83333L6.67364 1.98887C6.46854 1.76902 6.35405 1.4716 6.35533 1.16204C6.35662 0.852487 6.47359 0.556152 6.6805 0.33823C6.88741 0.120308 7.16732 -0.00135402 7.45866 1.35966e-05C7.74999 0.00138121 8.02888 0.125664 8.23397 0.34552L13.6814 6.17819C13.8855 6.39669 14 6.69204 14 6.99987C14 7.30769 13.8855 7.60304 13.6814 7.82155L8.23397 13.6542C8.1324 13.7632 8.0116 13.8499 7.87848 13.9092C7.74536 13.9685 7.60253 13.9994 7.45817 14C7.31381 14.0006 7.17076 13.971 7.0372 13.9127C6.90364 13.8545 6.78219 13.7689 6.67981 13.6608Z"
                fill="#27884D"
              />
            </svg>
          </router-link>
        </div>
      </div>
      <div class="m-card__main" :class="{ flex: double }">
        <div class="letter">{{ level }}</div>
        <div class="date">
          En base al nivel anterior del: <span>{{ date }}</span> <span v-if="week"> | {{week}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    double: {
      type: Boolean,
      default: false
    },
    data: {},
    number: {},
    title: {},
    titleB: {},
    name: {},
    action: {
      type: Boolean,
      default: false
    },
    url: {},
    date: {},
    week: {},
    level: {},
    currency: {}
  }
};
</script>
